export const MAX_EXCEL_ROWS = 500;
export const MAX_SHIPMENT_ITEMS = 5;
export const EXCEL_DATE_OFFSET = 25_569;
export const MS_IN_DAY = 86_400_000;
export const HEADER_ROWS = 3;
export const ERROR_OFFSET = HEADER_ROWS + 1;
export const MAX_ERROR_DISPLAY = 5;
export const EXCEPTION_FAILURE_MESSAGE =
	"An unexpected error occurred while processing the file. Please verify its contents or contact support.";

export const CARRIER_PREFERENCE_TOOLTIPS: Record<string, string> = {
	lowest_cost_preferred:
		"Selects the lowest cost carrier among TQL Preferred and Carrier of the Year carriers. If none are available, the lowest cost carrier is selected.",
};

export const CARRIER_PREFERENCE_OPTIONS = [
	{
		label: "TQL Preferred Carrier",
		value: "lowest_cost_preferred",
	},
	{
		label: "Fastest Transit",
		value: "lowest_cost_fastest",
	},
	{
		label: "Lowest Cost Carrier",
		value: "lowest_cost",
	},
	{
		label: "Let me choose each carrier",
		value: "manual",
	},
];

export const BULK_UPLOAD_TEMPLATE_PATHS = {
	quote: "/documents/bulk-upload-template.xlsx",
	tender: "/documents/bulk-tender-template.xlsx",
} as const;

export const REQUIRED_FIELDS = [
	"Pickup Date",
	"Origin Zip Code",
	"Origin City",
	"Origin State",
	"Origin Country",
	"Destination Zip Code",
	"Destination City",
	"Destination State",
	"Destination Country",
	"Shipper Location Type",
	"Delivery Location Type",
	"Item1 Description",
	"Item1 Quantity",
	"Item1 Unit Type",
	"Item1 Freight Class",
	"Item1 Weight",
	"Item1 Height",
	"Item1 Length",
	"Item1 Width",
];

export const TENDER_REPAIRABLE_FIELDS = [
	"Shipper Name",
	"Shipper Address1",
	"Shipper Start Hours",
	"Shipper End Hours",
	"Receiver Name",
	"Receiver Address1",
	"Receiver Contact Phone",
	"Receiver Start Hours",
	"Receiver End Hours",
];

export const TENDER_REQUIRED_FIELDS = REQUIRED_FIELDS;

export const TENDER_REQUIRED_HEADERS = [
	...TENDER_REQUIRED_FIELDS,
	...TENDER_REPAIRABLE_FIELDS,
	"Emergency Contact Name",
	"Emergency Contact Phone",
	...Array.from({ length: MAX_SHIPMENT_ITEMS }, (_, index) => {
		const item = index + 1;
		return [
			`Item${item} Case Count`,
			`Item${item} Is Hazmat`,
			`Item${item} NMFC`,
			`Item${item} UN Number`,
			`Item${item} Proper Shipping Name`,
			`Item${item} Hazmat Class`,
			`Item${item} Packing Group`,
		];
	}).flat(),
];

export const INSURANCE_REQUESTED_FIELD = "Insurance Requested";
export const INSURANCE_VALUE_FIELD = "Insured Value";
export const INSURANCE_PRODUCT_CONDITION_FIELD = "Insured Item Condition";

// Optional on purpose: workbooks downloaded before insurance shipped must still
// upload, so these are never added to TENDER_REQUIRED_HEADERS.
export const TENDER_INSURANCE_FIELDS = [
	INSURANCE_REQUESTED_FIELD,
	INSURANCE_VALUE_FIELD,
	INSURANCE_PRODUCT_CONDITION_FIELD,
];

export const INSURANCE_PRODUCT_CONDITIONS = [
	{ id: 1, name: "New" },
	{ id: 2, name: "Used" },
];

// Bulk tender never exposes the "Apply To" choice, so coverage always applies to
// all carriers, matching the hidden apply-to field in the insurance modal.
export const INSURANCE_APPLY_TYPE_ALL_CARRIERS = 1;

export const SERVICE_KEYS = [
	"Inside Pickup",
	"Pickup - Lift Gate",
	"Appointment Delivery",
	"Delivery Call Ahead",
	"Inside Delivery",
	"Delivery - Lift Gate",
	"Sort and Segregate",
	"Blind Single",
	"Blind Double",
	"In Bond",
	"Protect From Freezing",
];
